import * as React from 'react';

import { CategorySidebar } from './components/CategorySidebar';

import { TemplateData, CategoryData } from './App';
import { TemplateCard } from './components/TemplateCard';
import { TemplateHeader } from './components/TemplateHeader';
import { getCanoncialUrl } from './components/TemplateUtils';
import { RelatedTitle, SectionGray } from './styles/TemplatePage';

import { MetaTags } from './components/Meta';
import { WebsiteLogger } from '@prezi/client-logger-module';
declare const Site: any;

document.body.style.backgroundColor = '#152235';

export interface TemplatePageProps {
    currentTemplate: TemplateData;
    templates: Array<TemplateData>;
    categories: Array<CategoryData>;
    basePath: string;
    isAuthenticated: boolean;
    preloadPreviewVideos: boolean;
    categoryString: string;
    useThisTemplateCTA: string;
    getStartedCTA: string;
    relatedTemplatesString: string;
    usePARF: boolean;
}

export function doCategoriesIntersect(categories1: Array<String>, categories2: Array<String>): Boolean {
    return categories1.filter(category =>
            categories2.indexOf(category) !== -1,
        ).length !== 0;
}

export class TemplatePage extends React.Component<TemplatePageProps, any> {
    constructor(props: TemplatePageProps) {
        super(props);
    }

    getRelatedTemplates(currentTemplate: TemplateData): Array<TemplateData> {
        return this.props.templates.filter(template =>
            doCategoriesIntersect(template.categories, this.props.currentTemplate.categories) && template !== currentTemplate,
        );
    }

    logTemplateView = function() {
        WebsiteLogger.log({
            action: 'view',
            object: 'logged_element',
            trigger: 'view',
            payload: {element_text: this.props.currentTemplate.template_key,
                element_type: 'template_page',
                source_url: window.location.pathname,
                user_id: Site.user_id},
        });
    };

    componentDidMount() {
        this.logTemplateView();
    }

    componentDidUpdate() {
        this.logTemplateView();
    }

    render() {
        return (
            <div>
                <MetaTags
                    title={ this.props.currentTemplate.title }
                    description={ this.props.currentTemplate.description }
                    image={ this.props.currentTemplate.thumbnail_url }
                    slug={ this.props.currentTemplate.slug }
                    canonicalUrl={ getCanoncialUrl(this.props.currentTemplate.slug) }
                />
                <TemplateHeader
                    template={ this.props.currentTemplate }
                    isAuthenticated={ this.props.isAuthenticated }
                    preloadPreviewVideos={ this.props.preloadPreviewVideos }
                    useThisTemplateCTA={ this.props.useThisTemplateCTA }
                    getStartedCTA={ this.props.getStartedCTA }
                    usePARF={ this.props.usePARF }
                />
                <SectionGray className={ 'section' }>
                    <div className={ 'container' }>
                        <div className={ 'row' }>
                            <div className={ 'col-lg-2 visible-lg' }>
                                <CategorySidebar
                                    categories={ this.props.categories }
                                    basePath={ this.props.basePath }
                                    categoryString={ this.props.categoryString }
                                />
                            </div>
                            <div className={ 'col-xs-12 col-lg-10 pad-zero' }>
                                <div className={ 'col-xs-12' }>
                                    <RelatedTitle className={ ' h3 semibold related-title' }>{ this.props.relatedTemplatesString }</RelatedTitle>
                                </div>
                                { this.getRelatedTemplates(this.props.currentTemplate).map(template => (
                                    <TemplateCard key={ template.slug } template={ template } basePath={ this.props.basePath } />
                                )) }
                            </div>
                        </div>
                    </div>
                </SectionGray>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/TemplatePage.tsx